import React from 'react'
import { Operation, ReadOnlyModel } from '@morningtrain/react-resources'
import ExchangeActionsInner from 'widgets/shifts/exchange/ExchangeActionsInner'

export default function ExchangeActions ({
  slotId
}) {
  return (
    <ReadOnlyModel resourceName='shifts.schedule_slot' operationContext={{ schedule_slot: slotId }}>
      <Operation resourceName='shifts.schedule_slot' operationName='read' operationContext={{ schedule_slot: slotId }}>
        <ExchangeActionsInner />
      </Operation>
    </ReadOnlyModel>
  )
}
